export const CardState = {
    UNKNOWN: "UNKNOWN",
    REVEALED: "REVEALED"
}

export const CardType  = {
    BLUE_AGENT: "BLUE_AGENT",
    RED_AGENT: "RED_AGENT",
    CIVILIST: "CIVILIST",
    ASSASSIN: "ASSASSIN"
}

export const ViewModes = {
    MASTER: "MASTER",
    PLAYER: "PLAYER"

}

export const Themes = {
    DEFAULT: "DEFAULT",
    DARK: "DARK"
}